import { FC } from 'react';
import { termsAndConditionsHtml } from './dataFile';
import { TermsAndConditionsContainer } from './styled';

const TermsAndConditions: FC = () => (
    <TermsAndConditionsContainer dangerouslySetInnerHTML={{ __html: termsAndConditionsHtml }} />
);

export default TermsAndConditions;
